export default __webpack_public_path__ + "static/media/totalSaving.b4b4ba8a.svg";